import { ICategory } from 'contexts/@types/Layers';

export function mergeCategorias(prev: ICategory[], novas: ICategory[]): ICategory[] {
  const antigas = prev.filter(p => p.id_categoria !== 1000);

  const pesquisas = novas.map(nova => {
    const antiga = prev.find(a => a.id_categoria === nova.id_categoria);
    if (!antiga) return nova;

    return {
      ...nova,
      opened: antiga.opened,
      qtdOpenend: antiga.qtdOpenend,
      temas: nova.temas.map(novoTema => {
        const temaAntigo = antiga.temas.find(t => t.id_tema === novoTema.id_tema);
        if (!temaAntigo) return novoTema;

        return {
          ...novoTema,
          opened: temaAntigo.opened,
          qtdOpenend: temaAntigo.qtdOpenend,
          subtema: novoTema.subtema?.map(novoSub => {
            const subAntigo = temaAntigo.subtema?.find(s => s.id_subtema === novoSub.id_subtema);
            return subAntigo
              ? { ...novoSub, opened: subAntigo.opened, qtdOpenend: subAntigo.qtdOpenend }
              : novoSub;
          }),
        };
      }),
    };
  });

  return antigas.concat(pesquisas);
}